<div class="progress-bar-full w-100" [ngStyle]="{ 'background-color': secondaryColor }">
    <div class="progress-bar-current" [ngStyle]="{ width: barWidth, 'background-color': primaryColor }"></div>
</div>
